<script lang="ts" setup>
  import { useQuery } from '@tanstack/vue-query'

  import { REGIONS } from '~/constants/REGIONS'
  import { useRegionsService } from '~/core/services'
  import { LocationType } from '~/core/types'
  import { BngContentFit, BngPageFooter } from '~/layouts/components'

  const route = useRoute()
  const { getRegionGolfs, getRegion } = useRegionsService()

  const regionSlugId = computed((): string => getIdFromSlug(route.params.regionSlug as string ?? ''))

  function scrollTop() {
    const elem = document.getElementById('layout-observer-root')
    if (!elem) {
      return
    }
    elem.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const { data: region, isFetching: isFetchingRegion } = useQuery({
    queryKey: ['region', regionSlugId],
    queryFn: () => getRegion(regionSlugId.value),
  })

  const regionId = computed(() => region.value?.data?.id ?? null)
  const canFetchGolfs = computed(() => regionId.value !== null)
  const { data: golfs, isFetching: isFetchingGolfs } = useQuery({
    enabled: canFetchGolfs,
    queryKey: ['region', 'golfs', regionId],
    queryFn: () => getRegionGolfs(regionId.value),
  })

  const isFetching = computed(() => isFetchingGolfs.value || isFetchingRegion.value)

  const displayedRegion = computed(() => {
    const data = region.value ? REGIONS.find((r) => r.code === region.value?.data?.code) : null
    return data && region.value?.data ? { ...region.value.data, ...data } : null
  })

  useHead({
    title: 'Bookandgolf | Régions',
    meta: [
      {
        name: 'description',
        content: `Réservez votre départ au meilleur prix. Réservation 7j/7 24h/24`,
      },
    ],
  })

  onMounted(() => {
    if (!import.meta.server) {
      scrollTop()
    }
  })
</script>
<template>
  <div class="p-region">
    <BngContentFit>
      <RegionResumeSkeleton v-if="isFetching" />
      <RegionResume
        v-else-if="displayedRegion"
        :region="displayedRegion"
      />
    </BngContentFit>
    <div class="results">
      <GreenFeeList
        :golfs="golfs?.data ?? []"
        :is-fetching-golfs="isFetching"
        :location-type="LocationType.REGION"
      />
    </div>
    <RegionMoreRegions
      :key="regionSlugId"
      :region-id="regionSlugId"
    />
    <BngPageFooter />
  </div>
</template>
<style scoped>
.p-region {
  display: flex;
  width: 100%;
  flex: 0 0 auto;
  flex-direction: column;
  background: white;

  .c-results-list,
  .c-results-list.green-fee {
    --search-height: 0px;
  }
}
</style>
